import { withStyles } from '@material-ui/core/styles';
import Tooltip from '../../../../../../../common/StyledToolTip';

const styles = (theme) => ({
  header: {
    display: 'flex',
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  iconLayout: {
    float: 'left',
    color: theme.iconColor,
    cursor: 'pointer'
  },
  actionIcon: {
    fontSize: '14px'
  }
});

const Header = ({ classes, onMergePickupClick, disableMerge }) => {
  return (
    <div className={classes.header}>
      <div>Possible Duplicates</div>
      {!disableMerge && (
        <div
          className={classes.iconLayout}
          onClick={onMergePickupClick}>
          <Tooltip title='Merge Pickup'>
            <i className={`icon-merge-routes ${classes.actionIcon}`} />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(Header);
